import React, { useState, useEffect } from 'react';
import Header from '../component/Header';

// const API = 'https://whatsapp.hlgroups.in';
const API = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const AllDevices = () => {
    const [devices, setDevices] = useState([]);

    // --- NEW: State for Add Device Modal ---
    const [showAddModal, setShowAddModal] = useState(false);
    const [addPhone, setAddPhone] = useState('');
    const [countryType, setCountryType] = useState('India');
    const [isAdding, setIsAdding] = useState(false);

    // Fetch live data from your Express Backend
    const fetchDevices = async () => {
        try {
            const res = await fetch(`${API}/api/devices`);
            const data = await res.json();
            if (Array.isArray(data)) {
                setDevices(data);
            }
        } catch (e) {
            console.error("Failed to fetch devices:", e);
        }
    };

    // Auto-refresh the page every 2 seconds to keep QR/Status live
    useEffect(() => {
        fetchDevices();
        const t = setInterval(fetchDevices, 2000);
        return () => clearInterval(t);
    }, []);

    // --- NEW: Handle Add Device ---
    const handleAdd = async () => {
        if (!addPhone.trim()) return alert('Please enter a phone number.');

        // Clean the number (remove any non-digits)
        let cleanedNumber = addPhone.replace(/\D/g, '');

        // --- NEW: Length Validation & Country Code Assignment ---
        if (countryType === 'India') {
            if (cleanedNumber.length !== 10) {
                return alert('⚠️ Indian mobile numbers must be exactly 10 digits.');
            }
            cleanedNumber = '91' + cleanedNumber;
        } else if (countryType === 'Dubai') {
            if (cleanedNumber.length !== 9) {
                return alert('⚠️ Dubai/UAE mobile numbers must be exactly 9 digits (e.g., 501234567).');
            }
            cleanedNumber = '971' + cleanedNumber;
        }

        setIsAdding(true);
        try {
            const res = await fetch(`${API}/api/devices/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phoneNumber: cleanedNumber }) // Sending the fully formatted number
            });
            const result = await res.json();

            if (result.success) {
                setAddPhone('');
                setCountryType('India'); // Reset to default
                setShowAddModal(false);
                fetchDevices(); // Instantly refresh to show the new pairing code on the card
            } else {
                alert(result.error);
            }
        } catch (error) {
            alert('Server error. Could not connect to backend.');
        } finally {
            setIsAdding(false);
        }
    };

    // Handle Reconnect Action
    const handleReconnect = async (id) => {
        try {
            const res = await fetch(`${API}/api/devices/reconnect`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: id })
            });
            const result = await res.json();
            if (!result.success) alert(result.error);
            fetchDevices();
        } catch {
            alert('Reconnect failed. Server might be down.');
        }
    };

    // Handle Remove Action
    const handleRemove = async (id) => {
        if (!window.confirm(`Are you sure you want to permanently remove +${id}?`)) return;
        try {
            const res = await fetch(`${API}/api/devices/remove`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deviceId: id })
            });
            const result = await res.json();
            if (result.success) fetchDevices();
            else alert(result.error);
        } catch {
            alert('Remove failed. Server might be down.');
        }
    };

    // Helper to format the phone number nicely
    const formatPhone = (phone) => {
        if (!phone) return '';
        const str = String(phone);
        if (str.length === 12 && str.startsWith('91')) {
            return `+91 ${str.slice(2, 7)} ${str.slice(7)}`;
        }
        return `+${str}`;
    };

    return (
        <div className="wa-page">
            <style>{`
                .wa-page {
                    min-height: 100%;
                    background: #F8F9FA;
                }

                .wa-container {
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 0 24px 40px;
                }

                .wa-page-title {
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 4px;
                }

                .wa-page-subtitle {
                    color: #7A869A;
                    font-size: 0.95rem;
                    margin: 0;
                }

                .wa-btn-success {
                    background: #3BA949 !important;
                    border: none !important;
                    color: #FFFFFF !important;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                }

                .wa-btn-success:hover {
                    background: #339940 !important;
                    box-shadow: 0 6px 20px rgba(59, 169, 73, 0.35);
                }

                .pro-card {
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 1px solid #E5E7EB;
                    box-shadow: 0 4px 16px rgba(30, 58, 95, 0.06);
                    transition: transform 0.25s ease, box-shadow 0.25s ease;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    overflow: hidden;
                }

                .pro-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 28px rgba(30, 58, 95, 0.1);
                }

                .pro-card-header {
                    padding: 18px 20px;
                    background: #FFFFFF;
                    border-bottom: 1px solid #E5E7EB;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .device-title {
                    font-size: 1.05rem;
                    font-weight: 700;
                    color: #333333;
                    margin: 0;
                    line-height: 1.3;
                }

                .status-pill {
                    padding: 6px 12px;
                    border-radius: 50px;
                    font-size: 0.7rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    white-space: nowrap;
                    flex-shrink: 0;
                }

                .status-connected { background: #EAF4FE; color: #1A73E8; }
                .status-disconnected { background: #FCE8E6; color: #c0392b; }
                .status-waiting { background: #FFF3CD; color: #b76e00; }
                .status-init { background: #F0F5FA; color: #7A869A; }

                .pro-card-body {
                    padding: 24px 20px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }

                .pro-card-footer {
                    padding: 14px 20px;
                    background: #F8F9FA;
                    border-top: 1px solid #E5E7EB;
                }

                .state-icon {
                    font-size: 3rem;
                    margin-bottom: 12px;
                    line-height: 1;
                }

                .state-icon-success { color: #4CAF50; }
                .state-icon-warning { color: #f59e0b; }

                /* --- MODIFIED: Grid layout for both QR and Pairing Code --- */
                .auth-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;
                    width: 100%;
                    margin-bottom: 14px;
                }

                .qr-container {
                    background: #FFFFFF;
                    padding: 12px;
                    border-radius: 12px;
                    border: 1px solid #E5E7EB;
                    display: inline-block;
                }

                .qr-container img {
                    width: 160px;
                    height: 160px;
                    object-fit: contain;
                    display: block;
                }

                .pairing-code-box {
                    background: #EAF4FE;
                    border: 2px dashed #1A73E8;
                    border-radius: 12px;
                    padding: 16px;
                    width: 100%;
                }

                .pairing-code-text {
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #1A73E8;
                    letter-spacing: 5px;
                    margin: 0;
                    word-break: break-all;
                }

                .init-spinner {
                    width: 3rem;
                    height: 3rem;
                    color: #1A73E8 !important;
                    margin-bottom: 12px;
                }

                .btn-reconnect {
                    background: #3BA949 !important;
                    border: none !important;
                    color: #fff !important;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    border-radius: 50px !important;
                    padding: 8px 20px !important;
                    font-weight: 600;
                }

                .btn-reconnect:hover {
                    background: #339940 !important;
                }

                .custom-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(30, 58, 95, 0.5);
                    backdrop-filter: blur(4px);
                    display: flex; align-items: center; justify-content: center;
                    z-index: 1050;
                    padding: 16px;
                }

                .custom-modal {
                    background: #FFFFFF;
                    padding: 28px;
                    border-radius: 20px;
                    width: 100%;
                    max-width: 450px;
                    box-shadow: 0 20px 48px rgba(30, 58, 95, 0.18);
                    border: 1px solid #E5E7EB;
                }

                .page-header-row {
                    flex-wrap: wrap;
                    gap: 16px;
                }

                @media (max-width: 768px) {
                    .wa-container { padding: 0 16px 32px; }
                    .wa-page-title { font-size: 1.4rem; }
                    .pairing-code-text { font-size: 1.3rem; letter-spacing: 3px; }
                    .pro-card-header { padding: 16px; }
                    .pro-card-body { padding: 20px 16px; }
                }

                @media (max-width: 576px) {
                    .wa-page-title { font-size: 1.25rem; }
                    .page-header-row .btn { width: 100%; justify-content: center; }
                }
            `}</style>

            {/* HEADER PLACED AT THE ABSOLUTE TOP */}
            <Header title="All Devices" />

            <div className="wa-container mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4 page-header-row">
                    <div>
                        <h2 className="wa-page-title">All Devices Overview</h2>
                        <p className="wa-page-subtitle">Monitor and manage all your connected WhatsApp instances.</p>
                    </div>
                    <button
                        className="btn wa-btn-success fw-bold px-4 py-2 rounded-pill shadow-sm"
                        onClick={() => {
                            setAddPhone('');
                            setCountryType('India');
                            setShowAddModal(true);
                        }}
                    >
                        <i className="bi bi-plus-lg" aria-hidden="true" /> Link New WhatsApp
                    </button>
                </div>

                <div className="row g-4">
                    {devices.length === 0 ? (
                        <div className="col-12">
                            <div className="alert alert-light text-center py-5 rounded-4 border shadow-sm mb-0">
                                <i className="bi bi-phone fs-2 text-primary d-block mb-3" aria-hidden="true" />
                                <h4 className="text-muted mb-2">No devices found</h4>
                                <p className="text-muted mb-0 small">Click &quot;Link New WhatsApp&quot; to begin.</p>
                            </div>
                        </div>
                    ) : (
                        devices.map((device) => (
                            <div className="col-12 col-md-6 col-lg-4" key={device.id}>
                                <div className="pro-card">

                                    <div className="pro-card-header">
                                        <h3 className="device-title">{formatPhone(device.id)}</h3>
                                        {device.status === 'CONNECTED' && <span className="status-pill status-connected">Connected</span>}
                                        {device.status === 'DISCONNECTED' && <span className="status-pill status-disconnected">Disconnected</span>}
                                        {device.status === 'WAITING_FOR_QR' && <span className="status-pill status-waiting">Pending</span>}
                                        {device.status === 'INITIALIZING' && <span className="status-pill status-init">Booting</span>}
                                    </div>

                                    <div className="pro-card-body">
                                        {device.status === 'INITIALIZING' && (
                                            <>
                                                <div className="spinner-border init-spinner" role="status" />
                                                <h6 className="fw-bold text-muted mb-0">Requesting Session...</h6>
                                            </>
                                        )}

                                        {device.status === 'WAITING_FOR_QR' && (
                                            <>
                                                <div className="auth-container">
                                                    {device.pairingCode ? (
                                                        /* Show ONLY Pairing Code if it exists */
                                                        <div className="pairing-code-box">
                                                            <small className="text-muted fw-bold d-block mb-2">ENTER CODE ON PHONE</small>
                                                            <h2 className="pairing-code-text">
                                                                {device.pairingCode.match(/.{1,4}/g)?.join('-') || device.pairingCode}
                                                            </h2>
                                                        </div>
                                                    ) : (
                                                        /* Show QR Code ONLY if there is no pairing code */
                                                        (device.qrImage || device.qr) && (
                                                            <div className="qr-container shadow-sm">
                                                                <img
                                                                    src={device.qrImage || `${API}/api/qr-image?data=${encodeURIComponent(device.qr)}`}
                                                                    alt="WhatsApp QR Code"
                                                                />
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                                <h6 className="text-muted fw-bold mt-2 mb-0">Waiting for connection...</h6>
                                            </>
                                        )}

                                        {device.status === 'CONNECTED' && (
                                            <>
                                                <i className="bi bi-check-circle-fill state-icon state-icon-success" aria-hidden="true" />
                                                <h5 className="fw-bold text-success mb-1">Session Active</h5>
                                                <p className="text-muted small mb-0">Ready to send and receive messages.</p>
                                            </>
                                        )}

                                        {device.status === 'DISCONNECTED' && (
                                            <>
                                                <i className="bi bi-exclamation-triangle-fill state-icon state-icon-warning" aria-hidden="true" />
                                                <h5 className="fw-bold text-danger mb-2">Session Offline</h5>
                                                {device.error && (
                                                    <div className="alert alert-danger py-2 px-3 small text-start w-100 mb-3">
                                                        <strong>Error:</strong> {device.error}
                                                    </div>
                                                )}
                                                <button
                                                    className="btn btn-reconnect shadow-sm"
                                                    onClick={() => handleReconnect(device.id)}
                                                >
                                                    <i className="bi bi-arrow-clockwise" aria-hidden="true" /> Reconnect Device
                                                </button>
                                            </>
                                        )}
                                    </div>

                                    <div className="pro-card-footer d-flex justify-content-end">
                                        <button
                                            className="btn btn-sm btn-outline-danger rounded-pill px-3 fw-bold"
                                            onClick={() => handleRemove(device.id)}
                                        >
                                            <i className="bi bi-trash3 me-1" aria-hidden="true" /> Remove Device
                                        </button>
                                    </div>

                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* --- ADD DEVICE MODAL --- */}
            {showAddModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <h4 className="mb-4 fw-bold wa-page-title">Link New WhatsApp</h4>

                        <div className="form-group mb-3">
                            <label className="fw-bold text-muted small mb-2">Select Country Type</label>
                            <select
                                className="form-control form-control-lg bg-light"
                                value={countryType}
                                onChange={(e) => {
                                    setCountryType(e.target.value);
                                    setAddPhone(''); // Clear number when switching countries
                                }}
                                disabled={isAdding}
                            >
                                <option value="India">India (+91)</option>
                                <option value="Dubai">Dubai/UAE (+971)</option>
                            </select>
                        </div>

                        <div className="form-group mb-4">
                            <label className="fw-bold text-muted small mb-2">
                                Phone Number (Without Country Code)
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-lg bg-light"
                                placeholder={countryType === 'India' ? "Enter 10-digit number" : "Enter 9-digit number (e.g. 501234567)"}
                                value={addPhone}
                                onChange={(e) => setAddPhone(e.target.value)}
                                disabled={isAdding}
                                autoFocus
                            />
                            <small className="text-muted mt-2 d-block">We will instantly generate an 8-digit linking code for this number.</small>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                className="btn btn-light fw-bold me-2 px-4 rounded-pill"
                                onClick={() => setShowAddModal(false)}
                                disabled={isAdding}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-success fw-bold px-4 rounded-pill shadow-sm"
                                onClick={handleAdd}
                                disabled={isAdding}
                            >
                                {isAdding ? (
                                    <><span className="spinner-border spinner-border-sm me-2"></span> Generating...</>
                                ) : (
                                    'Generate Code'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllDevices;